import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { GDSIconProps } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import HomeIcon from 'assets/nav/home.svg';
import ServicesIcon from 'assets/nav/services.svg';
import JourneyIcon from 'assets/nav/journey.svg';
import MyHealthIcon from 'assets/nav/my-health.svg';
import HomeSelectedIcon from 'assets/nav/home-selected.svg';
import ServicesSelectedIcon from 'assets/nav/services-selected.svg';
import JourneySelectedIcon from 'assets/nav/journey-selected.svg';
import MyHealthSelectedIcon from 'assets/nav/my-health-selected.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

export interface NavLink {
  to:
    | string
    | {
        search: string;
        pathname: string;
        state: unknown;
        hash: string;
        key?: string | undefined;
      };
  label: string;
  icon?: GDSIconProps['icon'];
  iconSelected?: GDSIconProps['icon'];
}

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: NavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: 'STR_HOME' }),
      icon: HomeIcon,
      iconSelected: HomeSelectedIcon,
    },
    {
      to: APP_MANAGED_ROUTES.AUTHENTICATED_CARE_SERVICES,
      label: formatMessage({ id: 'STR_SERVICES' }),
      // need to get a illustrativeHealthClipboardFilled fo active state. its not available in genesis-core
      icon: ServicesIcon,
      iconSelected: ServicesSelectedIcon,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: 'STR_JOURNEY' }),
      icon: JourneyIcon,
      iconSelected: JourneySelectedIcon,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.aboutMe),
      label: formatMessage({ id: 'STR_MY_HEALTH' }),
      icon: MyHealthIcon,
      iconSelected: MyHealthSelectedIcon,
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
